<script setup lang="ts">
import { AuthLoginForm } from '../components/';

definePageMeta({
  layout: 'auth',
  auth: {
    unauthenticatedOnly: true,
    navigateAuthenticatedTo: '/',
  },
});

useHead({
  title: 'Login',
});
</script>

<template>
  <AuthLoginForm data-testid="login-form" />
</template>
